import React from 'react';
import logComponent from '../../common/logComponent';

export default function NewTab({ title, isSelected, baseClass, selectedClass, badge, selectPanel }) {
  if (logComponent('NewTab')) { console.debug('NewTab rendered'); }

  const handleClick = () => {
    if (logComponent('NewTab')) { console.debug('NewTab handleClick'); }
    selectPanel(title);
  }

  return (
    <li
      className="New-Tab">
      <button
        onClick={handleClick}
        className={baseClass + (isSelected ? ' ' + selectedClass : '')}>
        {title}
        {
          badge &&
          <span className="New-Tab__badge">{badge}</span>
        }
      </button>
    </li>
  );
}